import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from 'theme';

export const StyledDrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
  padding: ${spacing('md')};
  top: ${spacing('xl4')};
  position: relative;
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
  padding: ${spacing('md')};
  top: ${spacing('xl4')};
`;

export const Drawer = styled.aside`
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: #ffffff;
  padding: 1rem;
  overflow-y: auto;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #273043;
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
  color: #273043;
`;
export const HomeBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.55rem 0.9rem;
  border: 2px solid #d7dfe7;
  border-radius: 8px;
  background: transparent;
  font-weight: 600;
  color: #273043;
  cursor: pointer;
  margin-bottom: 1rem;

  svg {
    flex-shrink: 0;
  }
`;
export const Accordion = styled.div`
  border: 2px solid #d7dfe7;
  border-radius: 8px;
  overflow: hidden;
  margin-top: ${spacing('lg')};
`;
export const CategoryBlock = styled.div`
  border-bottom: 2px solid ${color('midnight_200')};

  &:last-child {
    border-bottom: none;
  }
`;

export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('bold')};
  color: ${color('black')} !important;
  text-align: left;
  text-decoration: none;

  &:hover {
    background-color: ${color('emerald_500')};
    color: ${color('white')};
  }
  &:hover a {
    color: ${color('white')};
  }
`;

export const CategoryLink = styled.a`
  flex: 1;
  text-decoration: none;
  color: inherit;
`;

export const ChevronBtn = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${color('white')};
  }
`;

export const SubList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: ${color('white')};
`;
export const SubLink = styled.a`
  display: block;
  width: 100%;
  padding: 0.55rem 1.25rem;
  border-bottom: 2px solid ${color('midnight_200')};
  text-align: left;
  text-decoration: none;
  color: #273043;
  cursor: pointer;

  &:hover {
    background-color: ${color('emerald_500')};
    color: ${color('white')};
  }

  &:last-child {
    border-bottom: none;
  }
`;
